import { useRef, useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import { Tooltip } from '@bizzabo/design-system';

interface TimePickerButtonWrapperPropsType {
    tooltipText: string;
    tooltipBoundaryRef: React.MutableRefObject<HTMLDivElement>;
    showTooltip?: boolean;
}

const TimePickerButtonWrapper: React.FC<TimePickerButtonWrapperPropsType> = ({
    children,
    showTooltip = false,
    tooltipText,
    tooltipBoundaryRef,
}) => {
    const [isTooltipOpen, setTooltipOpen] = useState<boolean>(false);
    const anchorRef = useRef<HTMLDivElement>(null);

    const classes = useStyles();
    return (
        <div
            className={classes.root}
            onMouseEnter={() => setTooltipOpen(true)}
            onMouseLeave={() => setTooltipOpen(false)}
        >
            <Tooltip
                open={showTooltip && tooltipText && isTooltipOpen}
                anchorRef={anchorRef}
                setOpen={setTooltipOpen}
                text={tooltipText}
                mainElementProps={{ role: 'alert' }}
                boundariesElement={tooltipBoundaryRef.current}
                flip={false}
                placement="top-end"
            >
                <div ref={anchorRef}>{children}</div>
            </Tooltip>
        </div>
    );
};

const useStyles = makeStyles(
    () => ({
        root: {
            width: '100%',
        },
    }),
    { classNamePrefix: 'time-picker-button-wrapper' }
);

export default TimePickerButtonWrapper;
